import { useState } from "react";
import { useTranslation } from "react-i18next";
import { requestPasswordReset } from "../../lib/api";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(""); const [err, setErr] = useState("");
  const onSubmit = async (e) => {
    e.preventDefault(); setMsg(""); setErr("");
    try { await requestPasswordReset(email);
      setMsg(t("forgotPassword.successMsg"));
    } catch { setErr(t("errors.generic")); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center">
      <form onSubmit={onSubmit} className="w-[420px] p-6 rounded-2xl shadow border space-y-4">
        <h1 className="text-2xl font-semibold">{t("forgotPassword.title")}</h1>
        {msg && <p className="text-green-600 text-sm">{msg}</p>}
        {err && <p className="text-red-600 text-sm">{err}</p>}
        <label className="block">
          <span className="text-sm">{t("forgotPassword.email")}</span>
          <input type="email" className="mt-1 w-full border rounded px-3 py-2"
                 value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <button className="w-full bg-black text-white rounded py-2">{t("forgotPassword.submit")}</button>
      </form>
    </div>
  );
}
